(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-cleats-lp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var frame = document.getElementById('phs-cleats-ppf-iframe');
    if (!frame) return;

    window.addEventListener('message', function (event) {
      var data = event.data;
      var nextHeight = null;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          data = null;
        }
      }
      if (data && typeof data === 'object') {
        nextHeight = data.height || data.iframeHeight || data.frameHeight;
      }
      if (!nextHeight) return;
      nextHeight = parseInt(nextHeight, 10);
      if (!nextHeight || nextHeight < 320) return;
      frame.style.height = Math.min(Math.max(nextHeight, 560), 1200) + 'px';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-gallery-systems-lp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var frame = document.getElementById('phs-gallery-ppf-iframe');
    if (!frame) return;
    window.addEventListener('message', function (event) {
      var data = event.data;
      var nextHeight = null;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (error) { data = null; }
      }
      if (data && typeof data === 'object') {
        nextHeight = data.height || data.iframeHeight || data.frameHeight;
      }
      if (!nextHeight) return;
      nextHeight = parseInt(nextHeight, 10);
      if (!nextHeight || nextHeight < 320) return;
      frame.style.height = Math.min(Math.max(nextHeight, 560), 1200) + 'px';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
